<template>
  <div class="section-portions">
    <b-row class="d-flex align-items-center mb-2 mt-1 px-2">
      <b-col>
        <span class="ap-title ap-title__main">{{ $tc('global.block', 2) }}</span>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <button
          v-tooltip="$tc('global.cleanFilter')"
          v-shortkey="['ctrl', 'alt', 'f']"
          type="button"
          class="btn btn__icon btn__icon--primary p-0 btn-secondary"
          @shortkey.prevent="cleanFilters"
          @click="cleanFilters"
        >
          <i
            class="far fa-filter"
            aria-hidden="true"
          />
        </button>
        <vt-report-export-buttons
          source="global-search-portions-grid"
          :export-report="exportReport"
        />
      </b-col>
    </b-row>
    <b-row class="px-1">
      <b-col>
        <vt-grid
          v-if="statesLoaded"
          :row-data="portions"
          :grid-options="gridOptions"
          class="portions-grid"
          :column-defs="columnDefs"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import { sectionPortionGridColumnDefs } from '@/modules/globalLocatorModule/sections/portion/section-portion-grid.column-defs'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import portionService from '@/api/resources/common/commonPortionServices'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import { GridUtils } from '@/shared/util/grid-utils'
import { portionState } from '@/api/resources/entityState/portion-state'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'PortionSection',
    components: {
        VtGrid
    },
    mixins: [
        GridExportMixin
    ],
    props: {
        foundItem: String,
        laboratoryId: { type: Number, required: true },
        caseId: { type: Number, required: true }
    },
    data() {
        return {
            detailCellRendererParams: null,
            portions: [],
            columnDefs: sectionPortionGridColumnDefs,
            columns: null,
            statesLoaded: false
        }
    },
    computed: {
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                onGridReady: this.onGridReady,
                getRowStyle: (params) => {
                    if (params.data.portionLabel === this.foundItem) {
                        return { background: '#CBF1E3 !important' }
                    }
                }
            }
        }
    },
    watch: {
        async caseId() {
            await this.loadPortions()
        }
    },
    async created() {
        await portionState.loadStates()
        this.statesLoaded = true
    },
    methods: {
        cleanFilters() {
            this.gridApi.setFilterModel(null)
        },
        onGridReady({ api }) {
            this.gridApi = api
            this.columnApi = api.columnModel
        },
        async loadPortions() {
            this.portions =
                await this.$_toCallSecure(
                    portionService.getPortionsByCaseId(this.laboratoryId, this.caseId))
        },
        exportReport(exportType) {
            const columns = this.$_getColumnsToExport(this.gridApi, this.columnApi)
            if (columns && this.gridApi) {
                return portionService.exportTo(
                    this.laboratoryId,
                    this.caseId,
                    this.foundItem,
                    this.gridApi.getFilterModel(),
                    GridUtils.getSortValue(this.gridApi.getSortModel()),
                    columns,
                    this.gridApi.getSelectedRows()?.map(portion => {
                        return portion?.id
                    }),
                    exportType)
            }
            return null
        }
    }
}
</script>

<style lang="scss" scoped>
  .portions-grid {
  height: calc(100vh - 350px) !important;
}

@media only screen and (max-width: 1366px) and (min-width: 1360px) {
   .portions-grid {
  height: calc(100vh - 290px) !important;
}
}

</style>

<style lang="scss">
.ag-status-bar{
  display: none;
}

</style>
